/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type UpdateKnowledgeDocumentBodyStatus =
  (typeof UpdateKnowledgeDocumentBodyStatus)[keyof typeof UpdateKnowledgeDocumentBodyStatus];

export const UpdateKnowledgeDocumentBodyStatus = {
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const;
